import formatToUSNumber from '../formatToUSNumber/index.js';

/**
 * Formatted Currency
 *
 * Returns a currency in the form of the US Dollar, Euro, Pound, or Yen in Default format
 *
 */
export default function formatCurrency(number, currency) {
  const defaultNumber = formatToUSNumber(number);
  switch (currency) {
    case '':
    case 'USD':
      return `$${defaultNumber}`;
    case 'EUR':
      return `€${defaultNumber}`;
    case 'GBP':
      return `£${defaultNumber}`;
    case 'JPY':
      return `¥${defaultNumber}`;
    default:
      return `$${defaultNumber}`;
  }
}